import { render, staticRenderFns } from "./NewProjectDetails.vue?vue&type=template&id=2ad7c05b&scoped=true"
import script from "./NewProjectDetails.vue?vue&type=script&lang=js"
export * from "./NewProjectDetails.vue?vue&type=script&lang=js"
import style0 from "./NewProjectDetails.vue?vue&type=style&index=0&id=2ad7c05b&prod&lang=scss"
import style1 from "./NewProjectDetails.vue?vue&type=style&index=1&id=2ad7c05b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad7c05b",
  null
  
)

export default component.exports